module.exports = __webpack_public_path__ + "static/media/Abfall.cd62bb8b.mp3";